<div [formGroup]="_data.roleForm" *ngIf="_data?.roleForm?.get('additionalFields')">
            <div formGroupName="additionalFields" class="p-fluid p-formgrid row">
          <div class="p-field col-lg-4 col-md-12 col-12">
            <label aria-labelledby="roletype" for="roletype" class="referral-form-labels">Role Type
              <span class="requiredfield text-danger">*</span>
            </label>
            <p-dropdown
  formControlName="cd_role_type"
  [options]="duplicateRoleTypeList"
  placeholder="Select Role Type"
  optionLabel="value"
  optionValue="key"
  [filter]="true"
  filterBy="value"
  [showClear]="true"
  [resetFilterOnHide]="true"
  inputId="roletype"
  (onClear)="onRoleTypeClear()"
  (onHide)="resetRoleTypeList()"
  (keyup)="searchRoleTypeList($event)">
</p-dropdown>

<!-- <div *ngIf="additionalFields?.get('cd_role_type')?.touched &&
           additionalFields?.get('cd_role_type')?.errors as errors" 
class="p-error block mt-1">
  Please select a role type.
</div>    -->
<div
  *ngIf="
    _data.roleForm.get('additionalFields.cd_role_type')?.invalid &&
    (_data.roleForm.get('additionalFields.cd_role_type')?.touched || submitted)
  "
  class="p-error mt-1">

  <div *ngIf="_data.roleForm.get('additionalFields.cd_role_type')?.errors?.['required']">
    Please select a role type.
  </div>

  <div *ngIf="_data.roleForm.get('additionalFields.cd_role_type')?.errors?.['customError']">
    {{ _data.roleForm.get('additionalFields.cd_role_type')?.errors?.['customError'] }}
  </div>
</div>
      
          </div>
</div>
 </div> 

